export const MAP_MODE_PARAM_KEY = 'mapMode';
